import { compose, bindActionCreators  } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import dataFetcher from "../../parts/chore/dataFetcher";
import { searchCampaignRecipients, searchMemberRecipients, searchTeamRecipients } from '../../search/searchActions';
import { getMembersInScope, sendMessage } from '../../messages/messageActions';
import { Form } from 'antd';

import SendMessagePage from './SendMessagePage';

const mapStateToProps = state => ({
  campaignRecipients: state.search.campaignRecipients.results,
  campaignSearch: state.search.campaignRecipients.search,
  campaignBatchNumber: state.search.campaignBatchNumber,
  isCampaignRecipientSearchInProgress: state.search.isCampaignRecipientSearchInProgress,
  teamRecipients: state.search.teamRecipients.results,
  teamSearch: state.search.teamRecipients.search,
  teamBatchNumber: state.search.teamBatchNumber,
  isTeamRecipientSearchInProgress: state.search.isTeamRecipientSearchInProgress,
  memberRecipients: state.search.memberRecipients.results,
  memberSearch: state.search.memberRecipients.search,
  memberBatchNumber: state.search.memberBatchNumber,
  isMemberRecipientSearchInProgress: state.search.isMemberRecipientSearchInProgress,
  accentColors: state.platform.platform.settings.color,
  isSendMessageInProgress: state.message.isSendMessageInProgress,
  selectedRecipients: state.message.selectedRecipients,
  locale: state.session.language,
  platformId: state.platform.platform.id
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchCampaignRecipients,
  searchMemberRecipients,
  searchTeamRecipients,
  getMembersInScope,
  sendMessage
 }, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  dataFetcher,
  Form.create()
)(SendMessagePage);